
























import Vue from 'vue';
// import util from '@/components/util';
import ModalBase from './ModalBaseV3.vue';

export default Vue.extend({
  name: 'ModalDeleteConfirm',
  // components: { ...util },
  components: { ModalBase },
  props: {
    deleteName: String,
    deleteNameChangeType: String,
  },
  data() {
    return {};
  },
  methods: {
    onClickDelete() {
      this.$emit('delete');
      this.onClickClose();
    },
    onClickClose() {
      this.$emit('close');
    },
  },
});
